import styled from '@emotion/styled';
import React from 'react';
import { useTransientAutoCreatedEventContext } from '../../../DraftEventStoreProvider';

export enum HeaderImageContainerTestId {
    Container = 'HeaderImageContainer',
}

export const HeaderImage = () => {
    const { transientAutoCreatedEvent } = useTransientAutoCreatedEventContext();

    if (!transientAutoCreatedEvent?.image_url) return null;

    return (
        <HeaderImageContainer
            aria-label="Event image"
            data-testid={HeaderImageContainerTestId.Container}
        >
            <StyledImage
                src={transientAutoCreatedEvent.image_url}
                alt="Header Image"
            />
        </HeaderImageContainer>
    );
};

const HeaderImageContainer = styled.section`
    width: 100%;
    height: 100%;
    border-radius: 8px;
    overflow: hidden;
`;

const StyledImage = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
`;
